<template>
    <div class="c-header"
        :class="{ 'is-notifs-active' : toggledPanel }"
        :data-component-name="$options.name"
    >
        <nav class="c-header-nav">
            <div class="c-header-nav__left">
                <div class="c-header-nav__item -burger js-header-burger" onclick="this.closest('.c-app').classList.toggle('is-mobile-nav-active');">
                    <div class="c-header-nav__button">
                        <div class="c-header-burger">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                    </div>
                </div>
                <div class="c-header-nav__item -logo -hidden-mobile">
                    <div class="c-header-nav__button" v-if="!$apollo.loading">
                        <div class="c-header-logo-text">
                            <!-- {{ siteSubscription.name }} -->
                            <SvgIcon name="logo" class="c-header-logo-svg" />
                        </div>
                    </div>
                </div>

                <div class="c-header-nav__item -search" v-if="myProfile.role == 'ADMINISTRATOR' || myProfile.role == 'MANAGER'">
                    <div class="c-header-search__wrap">
                        <GlobalSearch 
                            :currentDate="currentDate"
                        />
                        <TimeSheetPanel class="c-timesheet" />
                    </div>
                </div>
            </div>
            <div class="c-header-nav__right -hidden-desktop" v-if="currentRoute!='staffs'">
                <div class="c-header-nav__item -mobile-nav__item">
                    <router-link class="c-header-nav__button is-active" to="/help"
                        :class="{ 'is-current': currentRoute == 'help' }"
                    >
                        <SvgIcon name="alert" />
                        <div class="-label">Aide</div>
                    </router-link>
                </div>
                <!-- <div class="c-header-nav__item -mobile-nav__item">
                    <router-link class="c-header-nav__button is-active" to="/inbox"
                        :class="{ 'is-current': currentRoute == 'inbox' }"
                    >
                        <q-icon name="move_to_inbox" size="20px" />
                        <div class="-label">Réception</div>
                        <q-badge rounded color="red" class="-badge" floating transparent :label="unreadMessagesCount"></q-badge>
                    </router-link>
                </div> -->
                <!-- <div class="c-header-nav__item -mobile-nav__item">
                    <router-link class="c-header-nav__button is-active" to="/sent"
                        :class="{ 'is-current': currentRoute == 'sent' }"
                    >
                        <q-icon name="outbox" size="20px" />
                        <div class="-label">Envoyés</div>
                    </router-link>
                </div> -->
                <div class="c-header-nav__item -mobile-nav__item">
                    <router-link class="c-header-nav__button is-active" to="/pendings"
                        :class="{ 'is-current': currentRoute == 'pendings' }"
                    >
                        <q-icon name="all_inbox" size="20px" />
                        <div class="-label">Affectations</div>
                        <q-badge rounded color="red" class="-badge" floating transparent :label="pendingAssignmentsCount"></q-badge>
                    </router-link>
                </div>
                <div class="c-header-nav__item -mobile-nav__item">
                    <router-link class="c-header-nav__button is-active" to="/schedule"
                        :class="{ 'is-current': currentRoute == 'schedule' }"
                    >
                        <q-icon name="event_note" size="20px" />
                        <div class="-label">Horaire</div>
                    </router-link>
                </div>

                <!-- <div class="c-header-nav__item -mobile-nav__item -left-separator" v-if="currentRoute == 'schedule'">
                    <div class="c-header-nav__button is-active is-toggle">
                        <RangePicker
                            v-model="weekrange.str"
                            @set-current-date="$emit('set-current-date', $event)"
                        />
                        <div class="-label">Date</div>
                    </div>
                </div> -->
                <!-- <div class="c-header-nav__item -mobile-nav__item -calendar-toggle -left-separator" v-if="currentRoute == 'schedule' || currentRoute == 'scheduleList'">
                    <div class="c-header-nav__button is-toggle" @click="toggleCurrentSchedule">
                        <q-icon name="list" size="20px" class="" v-if="currentSchedule=='calendar'" title="Afficher la vue liste"></q-icon>
                        <div class="-label" v-if="currentSchedule=='calendar'">Liste</div>
                        <q-icon name="view_column" size="20px" class="" v-if="currentSchedule=='list'"  title="Afficher la vue calendrier"></q-icon>
                        <div class="-label" v-if="currentSchedule=='list'">Calendrier</div>
                    </div>
                </div> -->
            </div>


            <div class="c-header-nav__right" :class="{ '-hidden-mobile': currentRoute != 'staffs' }">


                <div class="c-header-nav__item -toggle -select__wrap" v-if="(currentRoute == 'schedule'  || currentRoute == 'pendings') && (myProfile.role=='ADMINISTRATOR' || myProfile.role=='MANAGER')">
                    <div v-if="myProfile.role=='ADMINISTRATOR' || myProfile.role=='MANAGER'">
                        <UserProfileInput
                            :rounded="true"
                            :standout="true"
                            :outlined="false"
                            :filled="false"
                            :dense="true"
                            :multiple="false"
                            v-model="userProfile"
                            label="Utilisateur"
                            @input="$emit('change-inbox', $event)"
                            :clearable="true"
                            :hide-selected="false"
                            :fill-input="true"
                            class="-o-userProfile-input"
                        />
                    </div>
                </div>

                <div class="c-header-nav__item -filters" v-if="currentRoute == 'staffs'">
                    <div class="c-filters-list">
                        <div class="c-filters-list__item -advanced">
                            <button class="o-button -sm js-filters-toggle" :class="{ 'is-active': moreFilters }"
                                @click="moreFilters = !moreFilters; $eventBus.$emit('toggle-more-filters', moreFilters);">
                                + Filtres avancés
                            </button>
                        </div>
                    </div>
                </div>

                <div class="c-header-nav__item -grid-view -left-separator" v-if="currentRoute == 'schedule' || currentRoute == 'staffs'">
                    <div class="c-header-nav__button is-toggle">
                        <RangePicker
                            v-model="weekrange.str"
                            @set-current-date="$emit('set-current-date', $event)"
                        />
                    </div>
                </div>
                
                <div class="c-header-nav__item -filters" v-if="currentRoute == 'projects'">
                    <div class="c-filters-list">
                        <div class="c-filters-list__item">
                            <button class="o-button -sm"
                                :class="{ 'is-active' : projectsFilter=='All' }"
                                @click="setProjectsFilter('All')"
                            >
                                Tout
                            </button>
                        </div>
                        <div class="c-filters-list__item">
                            <button class="o-button -sm"
                                :class="{ 'is-active' : projectsFilter=='MyProjects' }"
                                @click="setProjectsFilter('MyProjects')"
                            >
                                Mes projets
                            </button>
                        </div>
                        <div class="c-filters-list__item">
                            <button class="o-button -sm"
                                :class="{ 'is-active' : projectsFilter=='ToPlan' }"
                                @click="setProjectsFilter('ToPlan')"
                            >
                                À planifier
                            </button>
                        </div>
                        <div class="c-filters-list__item">
                            <button class="o-button -sm"
                                :class="{ 'is-active' : projectsFilter=='Actives' }"
                                @click="setProjectsFilter('Actives')"
                            >
                                Actifs
                            </button>
                        </div>
                        <!-- <div class="c-filters-list__item">
                            <button class="o-button -sm"
                                :class="{ 'is-active' : projectsFilter=='Confirmed' }"
                                @click="setProjectsFilter('Confirmed')"
                            >
                                Confirmés
                            </button>
                        </div> -->
                        <!-- <div class="c-filters-list__item">
                            <button class="o-button -sm"
                                :class="{ 'is-active' : projectsFilter=='To confirm' }"
                                @click="setProjectsFilter('To confirm')"
                            >
                                À confirmer
                            </button>
                        </div> -->
                        <div class="c-filters-list__item">
                            <button class="o-button -sm"
                                :class="{ 'is-active' : projectsFilter=='Drafts' }"
                                @click="setProjectsFilter('Drafts')"
                            >
                                Brouillons
                            </button>
                        </div>
                        <div class="c-filters-list__item">
                            <button class="o-button -sm"
                                :class="{ 'is-active' : projectsFilter=='Archived' }"
                                @click="setProjectsFilter('Archived')"
                            >
                                Archivés
                            </button>
                        </div>
                        <div class="c-filters-list__item  -advanced">
                            <button class="o-button -sm js-filters-toggle"
                                :class="{ 'is-active': moreFilters }"
                                @click="moreFilters=!moreFilters; $eventBus.$emit('toggle-more-filters', moreFilters);"
                            >
                                + Filtres avancés
                            </button>
                        </div>
                    </div>
                </div>
                <div class="c-header-nav__item -toggle -left-separator" v-if="currentRoute == 'projects' && currentView == 'weekView'">
                    <label class="o-switch__wrap">
                        <span class="o-switch__text text-no-wrap">Trier :</span>
                        <div class="c-project__name o-switch__text u-text-truncate" style="padding: unset">
                            <OrderBy :options="[
                                    { value: 'name', label: 'Nom du projet' },
                                    { value: 'updated_at', label: 'Date de mise à jour' },
                                    { value: 'created_at', label: 'Date de création' }
                                ]"
                                @update:orderBy="$eventBus.$emit('update:orderBy:weekView', $event);"
                                scope="weekView"
                            />
                        </div>
                    </label>
                </div>
                <div class="c-header-nav__item -toggle -left-separator" v-if="currentRoute == 'projects'">
                    <label class="o-switch__wrap">
                        <span class="o-switch__text">Afficher les noms</span>
                        <span class="o-switch">
                            <input type="checkbox" @input="toggleShiftsView($event)" :checked="shiftsView=='man'">
                            <span class="o-switch-slider -round"></span>
                        </span>
                    </label>
                </div>
                <div class="c-header-nav__item -grid-view -left-separator" v-if="currentRoute == 'projects'">
                    <div class="c-header-nav__button is-toggle" @click="toggleCurrentView">
                        <SvgIcon name="weekgrid" class="-idle" v-if="currentView=='weekView'" title="Afficher la vue mois"/>
                        <SvgIcon name="monthgrid" class="-idle" v-if="currentView=='monthView'" title="Afficher la vue semaine" />
                    </div>
                </div>
                <div class="c-header-nav__item -notif  -grid-view -left-separator" v-if="currentRoute == 'schedule' || currentRoute == 'scheduleList'">
                    <div class="c-header-nav__button is-toggle" @click="toggleCurrentSchedule">
                        <!-- <SvgIcon name="bell" class="" />-->
                        <q-icon name="list" size="20px" class="" v-if="currentSchedule=='calendar'" title="Afficher la vue liste"></q-icon>
                        <q-icon name="view_column" size="20px" class="" v-if="currentSchedule=='list'"  title="Afficher la vue calendrier"></q-icon>
                    </div>
                </div>
                <div class="c-header-nav__item -notif -left-separator -hidden-mobile">
                    <div class="c-header-nav__button is-active" @click="togglePanel($event)">
                        <SvgIcon name="bell" class="-notif-idle" />
                        <SvgIcon name="bell-filled" class="-notif-active" />
                        
                        <div style="position:relative; width:16px; height:16px;" v-if="unreadNotificationsCount>0"><q-badge rounded color="red" floating transparent :label="unreadNotificationsCount"></q-badge></div>
                    </div>
                </div>
                <!-- <div class="c-header-nav__item -notif -left-separator -hidden-desktop">
                    <router-link class="c-header-nav__button is-active" to="/inbox">
                        <SvgIcon name="bell" class="-notif-idle" />
                        <SvgIcon name="bell-filled" class="-notif-active" />
                        
                        <div style="position:relative; width:16px; height:16px;" v-if="unreadNotificationsCount>0"><q-badge rounded color="red" floating transparent :label="unreadNotificationsCount"></q-badge></div>
                    </router-link>
                </div> -->
                <div class="c-header-nav__item -profile -hidden-mobile " v-bind:class="{ 'is-open': toggle === 'c-header-profile-dropdown' }" @click="toggle = toggle !== 'c-header-profile-dropdown' ? 'c-header-profile-dropdown' : null">
                    <div class="c-header-nav__button" v-if="!$apollo.loading">
                        <UserAvatar 
                            :name="myProfile.name"
                            :email="myProfile.email"
                        />
                        <q-menu>
                            <q-list style="min-width: 100px">
                                <q-item clickable v-close-popup 
                                    v-for="(link, mi) in links"
                                    :key="mi"
                                >
                                    <q-item-section>
                                        <router-link class="text-no-wrap" :to="{ name: link.href}">
                                            <q-icon class="q-mr-sm" :name="link.icon" /> {{ link.name }}
                                        </router-link>
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </q-menu>

                    </div>
                </div>
            </div>
        </nav>

        <NotificationsPanel
            @set-current-date="$emit('set-current-date', $event)"
            :toggledPanel="toggledPanel"
        />

    </div>
</template>

<script>
    import GlobalSearch from '@/components/nav/GlobalSearch.vue'
    import TimeSheetPanel from '@/components/nav/TimesheetPanel.vue'
    import { v4 as uuidv4 } from 'uuid';
    import { MYPROFILE } from '@/graphql/user/queries'
    import { SITESUBSCRIPTION } from '@/graphql/siteSubscription/queries'
    import {getWeeksLimits} from '@/js/dateUtilities'
    export default {
        name: 'Header',
        components: { GlobalSearch, TimeSheetPanel },
        props: {
            currentView: {
                type: String,
                default: 'weekView'
            },
            currentSchedule: {
                type: String,
                default: 'list'
            },
            currentDate: String,
			inboxUserProfile: {
				type: Object,
				default: null,
			}
        },
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
            },
            siteSubscription: {
                query: SITESUBSCRIPTION,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
            },
        },
        data() {
            return {
                // inboxUserProfile: null,
                userProfile: null,
                weekrange: { str: null},
                links:[
                    // {
                    //     id:uuidv4(),
                    //     name:"Search",
                    //     href:"my-profile",
                    //     icon:"profile"
                    // },
                    {
                        id:uuidv4(),
                        name:"Mon profil",
                        href:"my-profile",
                        icon:"account_circle"
                    },
                    {
                        id:uuidv4(),
                        name:"Réglages",
                        href:"settings",
                        icon:"settings"
                    },
                    {
                        id:uuidv4(),
                        name:"Me déconnecter",
                        href:"logout",
                        icon:"power_settings_new",
                    }
                ],
                toggle : null,
                toggledPanel : false,
                loading: true,
                // currentView: "weekView",
                shiftsView: "profession",
                projectsFilter: "All",
                unreadNotificationsCount: 0,
                unreadMessagesCount: 0,
                pendingAssignmentsCount: 0,
                moreFilters: false
            }
        },
        mounted: async function() {
            this.weekrange=getWeeksLimits(this.currentDate, this.$generalSettings.settings.firstDayOfWeek)

            if(this.inboxUserProfile) this.userProfile=this.inboxUserProfile
            if(!this.inboxUserProfile){
                this.userProfile=this.myProfile
                this.$emit('change-inbox', this.myProfile)
            }
            // this.inboxUserProfile=this.myProfile;
            // 

            let shiftsView = this.$q.localStorage.getItem('shiftsView');
            if(shiftsView) this.shiftsView=shiftsView;
            this.$emit('set-current-shift-view', this.shiftsView)

            let projectsFilter = this.$q.localStorage.getItem('projectsFilter');
            if(projectsFilter) this.projectsFilter=projectsFilter;
            this.$emit('set-project-filter', this.projectsFilter)

            this.$eventBus.$on('set-notifs-count', function(e){
                this.unreadNotificationsCount=e.unreadMessagesCount+e.unreadErrorsCount;
                this.unreadMessagesCount=e.unreadMessagesCount;
                this.pendingAssignmentsCount=e.pendingAssignmentsCount;
            }.bind(this))

            this.$eventBus.$on('clear-more-filters', function(){
                this.moreFilters=false;
            }.bind(this))

        },
        beforeDestroy() {
            // this.$eventBus.$off('set-notifs-count');
        },
        methods: {
            togglePanel(){
                this.toggledPanel = this.toggledPanel==false
                // if(this.toggledPanel){
                // e.target.closest('.c-header').classList.toggle('is-notifs-active')

                // }
            },
			log(msg){
				console.log(msg)
			},
            // changeInbox(event){
            //     this.$emit('change-inbox', event)
			// },
            setProjectsFilter(value){
                this.projectsFilter=value;
                this.$q.localStorage.set('projectsFilter', value)
                this.$emit('set-project-filter', value);
            },
            toggleCurrentView(){
                if(this.currentView=='weekView'){
                    // this.currentView='monthView'
                    this.$emit('set-current-view', 'monthView')
                }else{
                    // this.currentView='weekView'
                    this.$emit('set-current-view', 'weekView')
                }
                // this.$emit('set-current-view', this.currentView)

            },
            toggleCurrentSchedule(){
                if(this.currentSchedule=='list'){
                    this.$emit('set-current-schedule', 'calendar')
                }else{
                    this.$emit('set-current-schedule', 'list')
                }
            },
            toggleShiftsView(e){
                this.shiftsView="profession"
                if(e.target.checked) this.shiftsView="man"
                this.$q.localStorage.set('shiftsView', this.shiftsView)
                this.$emit('set-current-shift-view', this.shiftsView)
            }
        },
        computed: {
            currentRoute: function(){
                // return this.$route.path.split('/')[1];
                return this.$route.name;
            }
        },
        watch: {
            currentDate: function(){
                this.weekrange=getWeeksLimits(this.currentDate, this.$generalSettings.settings.firstDayOfWeek)
            },
			inboxUserProfile: function(){
				if(this.inboxUserProfile) this.userProfile=this.inboxUserProfile;
			}
        }

    }
</script>

<style lang="scss">
    @import "@/scss/components/nav/Header.scss";
    @import "@/scss/components/filters/FiltersList.scss";
	@import "@/scss/components/dashboard/Timesheet.scss";

    .q-item {
        min-height: auto !important;
    }
</style>
